export default "__VITE_ASSET__QO0OdS7b__"